import gql from 'graphql-tag';

export default gql`
  mutation revokeAccessManager($channelId: UUID!, $userId: UUID!) {
    revokeAccessManager(channelId: $channelId, userId: $userId)
  }
`;
